<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <el-input
          v-model="search.title"
          placeholder="标题"
          clearable
          class="w-200px mr-10px"
        ></el-input>
        <el-input
          v-model="search.content"
          placeholder="内容"
          clearable
          class="w-200px mr-10px"
        ></el-input>
        <el-input
          v-model="search.createdUserId"
          placeholder="发起人"
          clearable
          class="w-200px mr-10px"
        ></el-input>
        <el-button type="primary" @click="searchTableData">搜索</el-button>
        <el-button type="primary" :disabled="!$hasAccess('create')" @click="openDialog('add')"
          >新增</el-button
        >
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        height="calc(100% - 104px)"
        class="mt-20px"
        ref="table"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="title" show-overflow-tooltip></el-table-column>
        <el-table-column label="内容" prop="content" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="发起人"
          prop="createdUserName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发起时间"
          prop="createdTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="流程节点"
          prop="processNoode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('submit') || scope.row.approvalStatus !== 1"
              size="mini"
              @click="submit(scope.row.id)"
              >提交</el-button
            >
            <!-- openDialog('approval', scope.row)  handleApproval( 'approval', scope.row) status: 1- 还未提交-->
            <el-button
              :disabled="!$hasAccess('approval') || scope.row.approvalStatus !== 2"
              size="mini"
              @click="handleApproval('approval', scope.row)"
              >审批</el-button
            >
            <el-button
              size="mini"
              @click="openDialog('update', scope.row)"
              :disabled="!$hasAccess('update', scope.row) || scope.row.approvalStatus !== 1"
              >编辑</el-button
            >
            <el-button size="mini" @click="handleApproval('read', scope.row)">查看</el-button>
            <el-button
              size="mini"
              @click="delData([scope.row.id])"
              :disabled="!$hasAccess('delete') || scope.row.approvalStatus !== 1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="page.pageNo"
        :page-size="page.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </el-card>

    <!-- 新增 -->
    <el-dialog
      :title="$t(`${dialogTitle}`)"
      :visible.sync="dialogVisible"
      :width="_.includes(['审批', '查看'], dialogTitle) ? '1400px' : '1000px'"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      v-dialogDrag
    >
      <div class="flex h-600px">
        <el-form
          class="flex-1 w-900px"
          :class="{ 'w-full': dialogTitle !== '审批' }"
          ref="form"
          :model="form"
          label-width="100px"
          :rules="rules"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="标准名称" prop="standardId">
                <el-select
                  v-model="form.standardId"
                  clearable
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="dialogTitle !== '新增'"
                  @change="changeStandardId"
                >
                  <el-option
                    v-for="item in standardIdList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实体名称" prop="classId">
                <el-select
                  v-model="form.classId"
                  clearable
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="dialogTitle !== '新增'"
                  @change="changeClassId"
                >
                  <el-option
                    v-for="item in classList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="_.includes(['新增', '编辑'], dialogTitle)">
              <el-button type="primary" @click="addAttr">添加</el-button>
              <el-button type="danger" @click="deleteAttr">删除</el-button>
            </el-col>
          </el-row>
          <el-table
            v-loading="attrLoading"
            border
            :data="attributeData"
            :highlight-current-row="true"
            height="500px"
            ref="attributeTable"
            @selection-change="selectAttr"
            row-key="id"
          >
            <el-table-column
              v-if="tableHeader.length"
              fixed
              :reserve-selection="true"
              type="selection"
              width="40"
            ></el-table-column>
            <el-table-column label="序号" width="60" v-if="tableHeader.length">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(val, index) in tableHeader"
              :prop="`${val.tableName}.${val.columnName}`"
              show-overflow-tooltip
              :key="index"
              :label="val.name"
              min-width="150"
            >
              <template slot-scope="scope">
                <div class="truncate">
                  {{ scope.row[`${val.tableName}.${val.columnName}`] }}
                  <span v-if="val.unit && scope.row[`${val.tableName}.${val.columnName}`]">{{
                    val.unit
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableHeader.length"
              label="数据修改内容"
              prop="update_json"
              min-width="200"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <div class="mt-20px">
            <el-pagination
              background
              @current-change="attrCurrentChange"
              @size-change="attrSizeChange"
              :current-page.sync="attrPage.pageNo"
              :page-size="attrPage.pageSize"
              :page-sizes="$pageSizeAll"
              layout="->, total, sizes, prev, pager, next, jumper"
              :total="attrPage.total"
            ></el-pagination>
          </div>
        </el-form>
        <div
          v-if="_.includes(['审批', '查看'], dialogTitle)"
          class="!w-400px h-full ml-10px bg-[#f5f7fa] p-10px"
        >
          <div class="mb-20px" v-if="dialogTitle === '审批'">
            <el-radio-group v-model="checkStatus" class="mb-20px">
              <el-radio :label="1">同意</el-radio>
              <el-radio :label="0">拒绝</el-radio>
            </el-radio-group>
            <el-input
              v-model="form.opinion"
              placeholder="请输入意见/评论"
              clearable
              type="textarea"
              class="mb-10px"
            ></el-input>
            <el-button
              type="primary"
              size="mini"
              v-loading="checkLoading"
              @click="handleWork"
              :disabled="checkStatus === ''"
              >处理工作</el-button
            >
          </div>
          <div class="!w-400px h-full" :class="{ 'h-[calc(100%-148px)]': dialogTitle === '审批' }">
            <approvalProcess class="h-full" :processForm="processForm" v-if="processForm.visible" />
          </div>
        </div>
      </div>
      <el-row slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="saveData"
          v-if="_.includes(['新增', '编辑'], dialogTitle)"
          >提交</el-button
        >
        <el-button size="small" @click="closeDialog">{{ $t('cancel') }}</el-button>
      </el-row>
    </el-dialog>

    <!-- 添加 -->
    <addAttributeData
      :dialogForm="dialogForm"
      :dialogTitle="dialogTitle"
      @closeDialogForm="closeDialogForm"
      @updateData="updateData"
    />
  </div>
</template>

<script>
import dataRuleSettingService from '@/services/DataRuleSettingService'
import StandardManagementService from '@/services/common/StandardManagementService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import addAttributeData from './components/addAttributeData'
import approvalProcess from './components/approvalProcess'

export default {
  name: 'ApprovalData',
  components: { addAttributeData, approvalProcess },
  data() {
    return {
      checkStatus: '',
      search: {
        title: '',
        content: '',
        createdUserId: '',
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: '',
      dialogVisible: false,
      form: {
        standardId: '',
        classId: '',
        opinion: '',
        id: '',
      },
      rules: {
        standardId: [{ required: true, message: '请选择标准名称', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择实体名称', trigger: 'blur' }],
      },
      standardIdList: [],
      classList: [],
      attributeData: [],
      attrPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dialogForm: {
        visible: false,
        classId: '',
      },
      selectAttrList: [],
      tableHeader: [],
      idList: [],
      attrLoading: false,
      processForm: {
        flowId: '',
        flowTaskId: '',
        visible: '',
      },
      checkLoading: false,
    }
  },
  created() {
    this.searchTableData()
  },
  methods: {
    handleApproval(types, row) {
      let paths = ''
      if (types == 'approval') {
        paths = './approval'
      } else {
        paths = './read'
      }
      this.$router.push({
        path: paths,
        query: {
          // flowId: row.flowId,
          // flowTaskId: row.flowTaskId,
          // standardId: row.standardId,
          // classId: row.classId,
          id: row.id,
        },
      })
    },
    // 处理工作
    handleWork() {
      if (this.checkStatus === 1) {
        this.passData()
      } else {
        this.rejectData()
      }
    },
    // 驳回
    async rejectData() {
      this.checkLoading = true
      const res = await dataRuleSettingService.passedOrRejected({
        id: this.form.id,
        opinion: this.form.opinion,
        isPass: false,
      })
      this.checkLoading = false
      if (res && res.code === 0) {
        this.$message.success('审批驳回')
        this.searchTableData()
        this.closeDialog()
      }
    },
    // 通过
    async passData() {
      this.checkLoading = true
      const res = await dataRuleSettingService.passedOrRejected({
        id: this.form.id,
        opinion: this.form.opinion,
        isPass: true,
      })
      this.checkLoading = false
      if (res && res.code === 0) {
        this.$message.success('审批通过')
        this.searchTableData()
        this.closeDialog()
      }
    },
    // 提交
    async submit(id, row) {
      const formData = new FormData()
      formData.append('approvalRecordId', id)
      const res = await dataRuleSettingService.commit(formData)
      if (res && res.code === 0) {
        this.$message.success('提交成功')
        this.searchTableData()
      }
    },
    delData(ids) {
      if (ids.length) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await dataRuleSettingService.deleteApprovalRecord(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.info('请选择需要删除的数据')
      }
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await dataRuleSettingService.getApprovalRecord({
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        title: this.search.title,
        content: this.search.content,
        createdUserId: this.search.createdUserId,
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    async openDialog(type, row) {
      if (localStorage.getItem('standardList')) {
        this.standardIdList = JSON.parse(localStorage.getItem('standardList'))
      } else {
        this.standardIdList = await this.getStandardList()
      }
      if (type === 'add') {
        this.dialogTitle = '新增'
      } else if (type === 'approval') {
        this.dialogTitle = '审批'
        this.processForm.flowTaskId = row.flowTaskId
        this.processForm.flowId = row.flowId
        this.processForm.visible = true
      } else if (type === 'update') {
        this.dialogTitle = '编辑'
      } else {
        this.dialogTitle = '查看'
        this.processForm.flowTaskId = row.flowTaskId
        this.processForm.flowId = row.flowId
        this.processForm.visible = true
      }
      if (type !== 'add') {
        _.assign(this.form, _.pick(row, ['id', 'standardId', 'classId']))
        this.getClassList()
        this.getDynamicTableHeader()
        this.getIdsByApprovalRecordId()
      }
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs.form.resetFields()
      this.form = this.$options.data().form
      this.$refs.attributeTable.clearSelection()
      this.tableHeader = []
      this.attributeData = []
      this.classList = []
      this.checkStatus = ''
      this.dialogVisible = false
      this.processForm.visible = false
    },
    saveData() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.attributeData.length === 0) {
            this.$message.warning('请添加数据')
            return
          }
          const dataIds = _.map(this.attributeData, (item) => {
            return item.id
          })
          if (this.form.id) {
            const res = await dataRuleSettingService.updateApprovalRecord({
              id: this.form.id,
              dataIds,
            })
            if (res && res.code === 0) {
              this.$message.success('修改成功')
              this.searchTableData()
              this.closeDialog()
            }
          } else {
            const res = await dataRuleSettingService.createApprovalRecord({
              standardId: this.form.standardId,
              classId: this.form.classId,
              createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
              dataIds,
            })
            if (res && res.code === 0) {
              this.$message.success('新增成功')
              this.searchTableData()
              this.closeDialog()
            }
          }
        }
      })
    },
    // 获取标准库
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        return res.data
      }
      return []
    },
    // 建立审批策略的实体
    async getClassList() {
      const res = await dataRuleSettingService.getApprovalStategyEntity(this.form.standardId)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    changeStandardId(val) {
      this.form.classId = ''
      this.attributeData = []
      if (val) {
        this.getClassList()
      } else {
        this.classList = []
      }
    },
    attrCurrentChange(num) {
      this.attrPage.pageNo = num
      this.searchAttrData()
    },
    attrSizeChange(size) {
      this.attrPage.pageSize = size
      this.searchAttrData()
    },
    // 添加
    addAttr() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogForm.classId = this.form.classId
          this.dialogForm.visible = true
        }
      })
    },
    deleteAttr() {
      if (this.selectAttrList.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.attributeData = _.difference(this.attributeData, this.selectAttrList)
      this.attrPage.total = this.attributeData.length
      this.$nextTick(() => {
        this.$refs.attributeTable.doLayout()
      })
    },
    closeDialogForm() {
      this.dialogForm.visible = false
    },
    updateData(val) {
      this.attributeData = this.attributeData.concat(val)
      // 去重
      this.attributeData = _.uniqBy(this.attributeData, 'id')
      this.attrPage.total = this.attributeData.length
      this.$nextTick(() => {
        this.$refs.attributeTable.doLayout()
      })
    },
    selectAttr(val) {
      this.selectAttrList = val
    },
    changeClassId(id) {
      this.attributeData = []
      if (id) {
        this.getDynamicTableHeader()
      }
    },
    // 获取实体数据管理动态表头
    async getDynamicTableHeader() {
      const res = await stdClassDataService.getDynamicTableHeader({
        classId: this.form.classId,
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      }
    },
    // 根据审批记录id获取数据id集合
    async getIdsByApprovalRecordId() {
      const res = await dataRuleSettingService.getIdsByApprovalRecordId(this.form.id)
      if (res && res.code === 0 && res.data) {
        this.idList = res.data
        this.searchAttrData()
      }
    },
    // 根据数据id获取动态表数据
    async searchAttrData() {
      this.attrLoading = true
      const res = await stdClassDataService.getDynamicTableData({
        classId: this.form.classId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        ids: this.idList,
      })
      this.attrLoading = false
      if (res && res.code === 0 && res.data) {
        this.attributeData = res.data
        this.attrPage.total = res.totalCount
      } else {
        this.attributeData = []
        this.attrPage.total = 0
      }
    },
  },
}
</script>
